export default __webpack_public_path__ + "static/media/cartao-icon.c6a471dd.svg";